<template>
    <div id="detalle">
        <div class="banner">
            <h2>BERRIES</h2>
        </div>
        <!-- <div class="flotante">
            <img src="@/assets/images/canasta.png" alt="">
        </div> -->
        <div class="inf">
            <div class="btns">
                <div id="btn1" class="btn active" @click="cambio('origen')">ORIGEN</div>
                <div id="btn2" class="btn" @click="cambio('variedades')">FRAMBUESA</div>
                <div id="btn3" class="btn" @click="cambio('dis')">ARÁNDANO</div>
                <div id="btn4" class="btn" @click="cambio('prop')">ZARZAMORA</div>
                <div id="btn5" class="btn" @click="cambio('info')">USOS</div>
            </div>
            <div id="bloques">
                <div id="origen">
                    <h2>Berries (Bayas)</h2>
                    <p>Tienen que ver con Frutos jugosos y carnosos que en su interior tienen semillas dispersas.
                      Tradicionalmente agrupamos en esta clasificación a las Fresas, Frambuesas, Arándanos, y Zarzamoras.
                    </p>
                </div>
                <div id="variedades">
                   <p>
                     La <span style="font-weight: bold">frambuesa</span>, conocida también como fresa del bosque, es un hermoso fruto del frambueso o sangüeso,
                     planta que crece silvestre en todos los países de clima templado. Es una fruta que aporta una cantidad destacable de fibra, que mejora el tránsito intestinal. Constituye una buena fuente de vitamina C,
                     ácido cítrico y ácido elágico, flavonoides y folatos, minerales como el potasio, el magnesio y el calcio.
                   </p>
                </div>
                <div id="disponibilidad">
                   <p>
                     El valor nutricional del <span style="font-weight: bold">arándano</span>, se resume como entre bajo y libre de grasas y sodio, libre de colesterol y rico en fibras,
                     refrescante, tónico, astringente, diurético y con vitamina C.; además de ácido hipúrico,
                     lo que determina que sea una fruta con muchas características deseables desde el punto de vista nutricional.
                     El pigmento que le confiere el color azul al fruto (la antocianina),
                     interviene en el metabolismo celular humano disminuyendo la acción de los radicales libres, asociados al envejecimiento,
                     cáncer, enfermedades cardíacas y Alzheimer.
                   </p>
                </div>
                <div id="propiedades">
                    <p>
                      La <span style="font-weight: bold">zarzamora</span> es una planta generalmente silvestre de la que se aprovechan sus frutos,
                      unas bayas pequeñas de color negro muy aromáticas y algo ácidas. Se consumen crudas,
                      aunque también se emplean en la elaboración de compotas, macedonias, tartas, etc.
                      Son ricas en vitaminas y minerales. Además aportan fibra y contienen pocas calorías.
                    </p>
                </div>
                <div id="info-nut">
                  <p>
                    Ayudan a combatir diarreas, gastroenteritis, colitis y cólicos menstruales
                  </p>
                  <p>
                    Enfermedades febriles: el jugo de este fruto es refrescante y tonificante,
                    por lo que resulta muy apropiado para los enfermos febriles o debilitados.
                  </p>
                  <p>
                    Afecciones bucofaríngeas: tiene un efecto beneficioso sobre las aftas (llagas) bucales,
                    gingivitis (inflamación de las encías), estomatitis (inflamación de la mucosa bucal), faringitis y amigdalitis.
                  </p>
                  <p>
                    Los frutos maduros tienen por su alto contenido en vitaminas son antiescorbúticas,
                    útiles también como astringentes y diuréticos; Ayuda contra la gripe, resfriados, tos y constipados.
                  </p>
                  <p>
                    Corrige las inflamaciones internas; Fortifica la sangre y el organismo en general
                  </p>
                  <p>
                    Evita la retención de líquidos, por lo que el consumo de esta fruta es ideal si estás realizando una dieta.
                    Contienen pocas calorías, evitas la inflamación y tu piel luce más bella y tersa. Previene el reumatismo.
                  </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    cambio(active) {
      const btn1 = document.getElementById('btn1');


      const btn2 = document.getElementById('btn2');


      const btn3 = document.getElementById('btn3');


      const btn4 = document.getElementById('btn4');


      const btn5 = document.getElementById('btn5');


      const origen = document.getElementById('origen');


      const variedades = document.getElementById('variedades');


      const disponibilidad = document.getElementById('disponibilidad');


      const propiedades = document.getElementById('propiedades');


      const inf = document.getElementById('info-nut');


      origen.style.display = 'none';
      variedades.style.display = 'none';
      disponibilidad.style.display = 'none';
      propiedades.style.display = 'none';
      inf.style.display = 'none';

      btn1.className = 'btn';
      btn2.className = 'btn';
      btn3.className = 'btn';
      btn4.className = 'btn';
      btn5.className = 'btn';

      if (active == 'origen') {
        console.log('origen');
        btn1.classList.add('active');
        origen.style.display = 'block';
      } else if (active == 'variedades') {
        console.log('var');
        btn2.classList.add('active');
        variedades.style.display = 'block';
      } else if (active == 'dis') {
        console.log('dis');
        btn3.classList.add('active');
        disponibilidad.style.display = 'block';
      } else if (active == 'prop') {
        console.log('props');
        btn4.classList.add('active');
        propiedades.style.display = 'block';
      } else {
        console.log('info');
        btn5.classList.add('active');
        inf.style.display = 'block';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#detalle {
  .active {
    background: gray !important;
    display: block;
  }
  .banner {
      height: 50vh;
      background-image: url('../../assets/images/grid/7.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      h2 {
          position: relative;
          top: 10%;
          color: #fff;
          font-size: 2.2em;
          font-weight: bold;
      }
  }
  .flotante {
      position: relative;
      top: -30vh;;
      z-index: 10;

  }
  .inf {
      // position: relative;
      // top: -30vh;
      .btns {
          margin: 2% auto;
          margin-bottom: 4%;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .btn {
            cursor: pointer;
              width: 200px;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 5px 15px;
              color: #fff;
              background-color: green;
              border-radius: 10px;
              padding: 10px 30px;
          }
          .btn:nth-child(5) {
              width: 300px;
          }
      }
      #bloques {
          text-align: justify;

        > div {
            color: gray;
            font-size: 1.3em;
            margin: 0 20%;
            h2 {
              text-align: center;
            }
        }
        #origen {
          display: block;

          h2 {
            text-align: center;
          }
        }
        #variedades {
            display: none;
        }
        #disponibilidad {
            display: none;
        }
        #propiedades {
            display: none;
        }
        #info-nut {
            display: none;
        }
      }
  }
}
@media screen and (max-width: 600px) {
  #detalle .inf div.btns {

  }
}
</style>
